
let parseMolecule = (molecule, type, aName, aType, aSubType=null) => {
  return (molecule.atoms || []).filter(atom => {
    return atom.type === type;
  }).filter(atom => {
    for (let annotation of (atom.annotations || [])) {
      let { name, type, subtype } = annotation;
      return (
        (aName === null || aName === name) &&
        (aType === null || aType === type) &&
        (aSubType === null || aSubType === subtype)
      );
    }
    return false;
  });
}


let parseMoleculeFirst = (
    molecule, type, aName, aType, aSubType=null, field='content'
  ) => {
  const atoms = (molecule.atoms || []).filter(atom => {
    return atom.type === type;
  })
  for (let atom of atoms) {
    for (let annotation of (atom.annotations || [])) {
      let { name, type, subtype } = annotation;
      if (
        (aName === null || aName === name) &&
        (aType === null || aType === type) &&
        (aSubType === null || aSubType === subtype)
      ) {
        return atom[field];
      }
    }
  }
  return null;
}

let hyphenToCamel = (s) => {
  return s.replace(/(-\w)/g, m => {return m[1].toUpperCase();});
}


export default {
  parseMoleculeFirst: parseMoleculeFirst,
  parseMolecule: parseMolecule,
  hyphenToCamel: hyphenToCamel,
};



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCardUtils.jsx